import { CensusFormProvider } from '../components/provider/CensusFormProvider';
import CensusCreateTabs from './CensusCreateTabs';

export default function CensusCreatePage({ fromPark }: { fromPark?: boolean }) {
  return (
    <CensusFormProvider speciesFilter="census">
      <CensusCreateTabs fromPark={fromPark} />
    </CensusFormProvider>
  );
}